import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Loader2, ArrowLeft, Calendar, FileText } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function LegalPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_URL}/api/legal/${slug}`);
        setDoc(res.data);
      } catch (err) {
        setError(err.response?.data?.detail || 'Document not available');
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  return (
    <div className="min-h-screen bg-background py-12 px-4" data-testid="legal-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-muted-foreground hover:text-gold mb-8 text-sm uppercase tracking-widest">
          <ArrowLeft className="w-4 h-4 mr-2" /> Back
        </Link>

        {loading && (
          <div className="flex items-center justify-center py-24 text-muted-foreground">
            <Loader2 className="w-5 h-5 mr-2 animate-spin" /> Loading…
          </div>
        )}

        {error && !loading && (
          <div className="wm-card p-10 text-center">
            <FileText className="w-10 h-10 text-muted-foreground mx-auto mb-4" />
            <h1 className="text-2xl font-playfair font-bold mb-2">Document unavailable</h1>
            <p className="text-muted-foreground text-sm">{error}</p>
          </div>
        )}

        {doc && !loading && (
          <div className="wm-card p-8 sm:p-12">
            <h1 className="text-3xl sm:text-4xl font-playfair font-bold text-foreground mb-2" data-testid="legal-title">
              {doc.title}
            </h1>
            <div className="flex items-center gap-4 text-xs text-muted-foreground uppercase tracking-widest mb-8">
              <span className="flex items-center gap-1">
                <Calendar className="w-3.5 h-3.5" /> Effective {doc.effective_date}
              </span>
              <span>Version {doc.version}</span>
            </div>
            <article className="prose prose-invert max-w-none prose-headings:font-playfair prose-headings:text-foreground prose-strong:text-foreground prose-a:text-gold hover:prose-a:underline prose-li:text-muted-foreground prose-p:text-muted-foreground">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{doc.content_md}</ReactMarkdown>
            </article>
          </div>
        )}
      </div>
    </div>
  );
}
